import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { VendorsService } from 'src/app/services/vendors.service';
import { VendorDto } from 'src/app/models/VendorDto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { TokenService } from 'src/app/services/token.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExcelexportService } from 'src/app/services/excelexport.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { ManpowerapprovalService } from 'src/app/services/manpowerapproval.service';
import { ManPowerApprovalDto } from 'src/app/models/manpowerapproval-dto';
import * as FileSaver from 'file-saver';
import { ManpowerJDDto } from 'src/app/models/requests/ManpowerJDDto';
import { MovementPendingApprovalDto } from 'src/app/models/MovementPendingApprovalDto';
import { ManPowerPendingApprovalDto } from 'src/app/models/ManPowerPendingApprovalDto';
import { DocumentsService } from 'src/app/services/documents.service';
import { ManpowerrecruitmentService } from 'src/app/services/manpowerrecruitment.service';
import { approveManPowerVm } from 'src/app/models/approveManPowerVm';
import { startAdvertVM } from 'src/app/models/startAdvertVM';
import { CloseRecruitmentVM } from 'src/app/models/CloseRecruitmentVM';
import { acceptOfferVM } from 'src/app/models/acceptOfferVM';

@Component({
  selector: 'app-manpower-recruitment',
  templateUrl: './manpower-recruitment.component.html',
  styleUrls: ['./manpower-recruitment.component.css']
})
export class ManpowerRecruitmentComponent implements OnInit {

  currentUser: any;
  Requests: ManPowerDto[] = [];
  UpdateRequest: any;
  receivedfile: string = '';
  advertDuration: string = '';
  shortListingDuration: string = '';
  interviewDuration: string = '';
  OfferProcessDuration: string = '';
  pdf: string = "";
  isTerminationVisible: boolean = false;
  isStartAdvertRecruitmentVisible: boolean = false;
  isEndAdvertRecruitmentVisible: boolean = false;
  isstartShortlistingRecruitmentVisible: boolean = false;
  isEndShortlistingRecruitmentVisible: boolean = false;
  isStartInterviewRecruitmentVisible: boolean = false;
  isEndInterviewRecruitmentVisible: boolean = false;
  isStartOfferRecruitmentVisible: boolean = false;
  isEndOfferRecruitmentVisible: boolean = false;
  isOnHoldRecruitmentVisible: boolean = false;
  isCloseInternalOrExternalVisible:boolean = false;
  isAcceptOfferRecruitmentVisible: boolean = false;
  isCloseRecruitmentVisible: boolean = false;
  isShowCancelRequest: boolean = false;
  startAdvertVisible: boolean = false;
  endAdvertVisible: boolean = false;
  startShortlistingVisible: boolean = false;
  endShortlistingVisible: boolean = false;
  startInterviewVisible: boolean = false;
  endInterviewVisible: boolean = false;

  advertVisible: boolean = false;
  shortListingVisible: boolean = false;
  interviewVisible: boolean = false;
  OfferProcessVisible: boolean = false;
  advertEndVisible: boolean = false;
  shortListingEndVisible: boolean = false;
  interviewEndVisible: boolean = false;
  OfferProcessEndVisible: boolean = false;
  acceptOfferVisible: boolean = false;
  showClosedRecruitment: boolean = false;
  

  startOfferManagementVisible: boolean = false;
  EndOfferManagementVisible: boolean = false;
  OfferAcceptedVisible: boolean = false;
  onHoldVisible: boolean = false;
  closed: boolean = false;
  isChangeOkLoading = false;
  isShowRejectionMessage = false;
  canCreateManpower: boolean = false;
  isCloseModalVisible: boolean = false;
  closeModalTitle: string = "";
  ManPowerRequestApprovals: ManPowerApprovalDto[] | undefined;
  ManPowerPendingRequestApprovals: ManPowerPendingApprovalDto[] | undefined;
  ManPowerJD: ManpowerJDDto[] | undefined;
  canPrint: boolean = false;
  cancelComment: string = "";
  advertStartDate: Date | null = null;
  advertEndDate: Date | null = null;
  shortlistingStartDate: Date | null = null;
  shortlistingEndDate: Date | null = null;
  interviewStartDate: Date | null = null;
  interviewEndDate: Date | null = null;
  offerManagementStartDate: Date | null = null;
  offerManagementEndDate: Date | null = null;
  onHoldDate: Date | null = null;
  acceptOfferDate: Date | null = null;
  recruitmentClosedDate: Date | null = null;
  assumptionDate: Date | null = null;
  Band: string = '';
  lastName: string = '';
  firstName: string = '';
  middleName: string = '';
   hireType: 'internal' | 'external' | '' = '';
     recordId!: number;
     selectedRecordId!: number;

  band = [
    { name: "A"},
    {  name: "B"},
    {  name: "C"},
    { name: "D"},
    { name: "E"},
    { name: "F"},
    { name: "F PLUS"},
    { name: "G"},
    { name: "H"}
 ];
  message: string = '';
  filter: any
  ViewlevelOfCompliance = false;
  isCancelVisible: boolean = false;
  ViewManpowerRequestVisible = false;
  ViewManpowerRecruitment = false;
  isPendingpprovalModalVisible = false;
  constructor(private router: Router, public datepipe: DatePipe, private manPowerService: ManPowersService, private notification: NotificationService,
    private vendorService: VendorsService, private manpowerApprovalService: ManpowerapprovalService,
    private tokenService: TokenService, private fb: FormBuilder, private documentService: DocumentsService, private manpowerrecruitmentService: ManpowerrecruitmentService) { }

  ngOnInit(): void {
    
    this.filter = history.state.data;
    this.loadRecords(this.filter);

  }

  downloadExcel() {
    
    const exportData: Partial<object>[] = this.Requests.map(

      x => ({

        Reference: x.reference,          
        Requester: x.createdBy,
        RequestDate: x.createdDate,
        Status: x.isActive ? 'Active' : 'Inactive',
        Designation: x.requesterDesignation,
        Function: x.requesterFunction,
        Unit: x.requesterUnit,
        Jobtitle: x.jobTitle,
        NPlus1Designation: x.nPlus1Designation,
        Band: x.band,
        CostCenter: x.costCenter,
        Location: x.location,
        DateVacancyOccurred: x.dateVacancyOccurred,
        RequiredNumber: x.requiredNumber,
        TypeOfVacancy: x.typeOfVacancy,
        ReasonForVacancy: x.reasonForVacancy,
        ModeOfRecruitment: x.modeOfRecruitment,
        DurationOfContract: x.durationOfContract,
        EstimatedAnnualCost: x.estimatedAnnualCost,
        CreatedBy: x.createdBy,
        justificationForVacancy: x.justificationForVacancy,
        Qualification: x.qualification,
        SkillsRequired: x.skillsRequired,
        Experience: x.experience,
        SystemRequired: x.systemRequired,
        OtherSystemRequirements: x.otherSystemRequirements,
        vacancyStatus : x.vacancyStatus,
        DateApproved: x.DateApproved,
        durationOfApproval:x.durationOfApproval,
        advertStartDate: x.advertStartDate,
        advertStartMessage: x.advertStartMessage,
        advertEndDate: x.advertEndDate,
        advertEndMessage: x.advertEndMessage,
        advertDuration: x.advertDuration,
        shortlistingStartDate : x.shortlistingStartDate,
        shortListingStartMessage : x.shortListingStartMessage,
        shortlistingEndDate : x.shortlistingEndDate,
        shortListingEndMessage : x.shortListingEndMessage,
        shortlistingDuration: x.shortlistingDuration,
        interviewStartDate : x.interviewStartDate,
        interviewStartMessage : x.interviewStartMessage,
        interviewEndDate : x.interviewEndDate,
        interviewEndMessage : x.interviewEndMessage,
        interviewDuration : x.interviewDuration,
        offerProcessStartDate : x.offerProcessStartDate,
        offerProcessStartMessage : x.offerProcessStartMessage,
        offerProcessEndDate : x.offerProcessEndDate,
        offerProcessEndMessage : x.offerProcessEndMessage,
        offerManagementDuration : x.offerManagementDuration,
        acceptanceDate : x.acceptanceDate,
        employedFirstname : x.employedFirstname,
        employedMiddleName : x.employedMiddleName,
        employedLastname : x.employedLastname,
        employedGrade : x.employedGrade,
        recruitmentCloseDate : x.recruitmentCloseDate,
        recruitmentCloseMessage : x.recruitmentCloseMessage,
        onHoldStartDate : x.onHoldStartDate,
        assumptionDate : x.assumptionDate,
        onHoldMessage : x.onHoldMessage,
        timeOfHire : x.timeOfHire,
        showStartAdvertOption: x.showStartAdvertOption,

      })
    );
    ExcelexportService.exportArrayToExcel(exportData, 'ManPower Recruitment')
  }

  handleCancel(): void {

    this.isStartAdvertRecruitmentVisible = false;
    this.isEndAdvertRecruitmentVisible = false;
    this.isstartShortlistingRecruitmentVisible = false;
    this.isEndShortlistingRecruitmentVisible = false;
    this.isStartInterviewRecruitmentVisible = false;
    this.isEndInterviewRecruitmentVisible = false;
    this.isStartOfferRecruitmentVisible = false;
    this.isEndOfferRecruitmentVisible = false;
    this.isCloseRecruitmentVisible = false;
    this.isOnHoldRecruitmentVisible = false;
    this.isCloseInternalOrExternalVisible= false;
    this.isAcceptOfferRecruitmentVisible = false;
    this.ViewManpowerRecruitment = false;

  }


  async open(data: ManPowerDto) {
    
    this.ViewManpowerRequestVisible = true;
    this.UpdateRequest = data;

    this.currentUser = this.tokenService.getInfo();
    if (data.status === "Approved") { this.canPrint = true }
    let resApprovals = await this.manpowerApprovalService.getRequestApprovals(data.id).toPromise();
    this.ManPowerRequestApprovals = <ManPowerApprovalDto[]>resApprovals.responseData;

    this.UpdateRequest = data;
  }

  
  async openRecruitment(data: ManPowerDto) {
    
    this.ViewManpowerRecruitment = true;
    this.UpdateRequest = data;
    this.currentUser = this.tokenService.getInfo();
    if (data.status === "Approved") { this.canPrint = true }
    let resApprovals = await this.manpowerApprovalService.getRequestApprovals(data.id).toPromise();
    this.ManPowerRequestApprovals = <ManPowerApprovalDto[]>resApprovals.responseData;

    this.UpdateRequest = data;
    this.advertDuration  = this.UpdateRequest.advertDuration + " " + "Day(s)"
    this.shortListingDuration = this.UpdateRequest.shortlistingDuration + " " + "Day(s)"
    this.interviewDuration  = this.UpdateRequest.interviewDuration + " " + "Day(s)"
    this.OfferProcessDuration =  this.UpdateRequest.offerManagementDuration  + " " + "Day(s)"
     if(data.vacancyStatus == 'Pending'){
      this.advertVisible = false
      this.advertEndVisible = false
      this.shortListingVisible = false
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus == 'Advert_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = false
      this.shortListingVisible = false
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
     
    }
    if(data.vacancyStatus == 'Advert_Ended'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = false
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus == 'Shortlisting_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus == 'Shortlisting_Concluded'){
      this.advertVisible = true
      this.advertEndVisible = false
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'Interview_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'Interview_Concluded'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'OfferManagement_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'OfferManagement_Concluded'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = true
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'OfferAccepted'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = true
      this.acceptOfferVisible = true
    }

    if(data.vacancyStatus === 'Closed'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = true
      this.acceptOfferVisible = true
    }
    
  }

  async sendStartAdvert() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.advertStartDate };

    this.manpowerrecruitmentService.startAdvert(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          this.isStartAdvertRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }

  async sendEndAdvert() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.advertEndDate };

    this.manpowerrecruitmentService.EndAdvert(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isEndAdvertRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendStartShortlisting() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.shortlistingStartDate };

    this.manpowerrecruitmentService.StartShortlisting(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isstartShortlistingRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }

  async sendEndShortlisting() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.shortlistingEndDate };

    this.manpowerrecruitmentService.ShortListing(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isEndShortlistingRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendStartInterview() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.interviewStartDate };

    this.manpowerrecruitmentService.StartInterview(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isStartInterviewRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }

  async sendEndInterview() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.interviewEndDate };

    this.manpowerrecruitmentService.StopInterview(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isEndInterviewRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendStartOfferManagement() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.offerManagementStartDate };

    this.manpowerrecruitmentService.StartOfferProcess(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isStartOfferRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendOnHold() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.onHoldDate };

    this.manpowerrecruitmentService.PutonHold(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isEndOfferRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendAcceptOffer() {
    
    const model: acceptOfferVM = { id: this.UpdateRequest.id,EmployedMiddleName:this.middleName, EmployedFirstname: this.firstName,EMployedLastname: this.lastName, EMployedGrade: this.Band, message: this.message, Date: this.acceptOfferDate };

    this.manpowerrecruitmentService.AcceptOffer(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isEndOfferRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendEndOfferManagement() {
    
    const model: startAdvertVM = { id: this.UpdateRequest.id, message: this.message, Date: this.offerManagementEndDate };

    this.manpowerrecruitmentService.EndOfferProcess(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          // this.loadRecords();
          this.isEndOfferRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async sendCloseRecruitment() {
    
    const model: CloseRecruitmentVM = { id: this.UpdateRequest.id, message: this.message, recruitmentClosedDate: this.recruitmentClosedDate, AssumptionDate: this.assumptionDate };

    this.manpowerrecruitmentService.CloseRecruitment(model).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });


          this.isStartAdvertRecruitmentVisible = false;
          location.reload()

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });

  }


  async openStartAdvert(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isStartAdvertRecruitmentVisible = true;

  }

  async openEndAdvert(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isEndAdvertRecruitmentVisible = true;

  }

  async openStartShortlisting(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isstartShortlistingRecruitmentVisible = true;

  }

  async openEndShortlisting(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isEndShortlistingRecruitmentVisible = true;

  }

  async openStartInterview(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isStartInterviewRecruitmentVisible = true;

  }

  async openEndInterview(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isEndInterviewRecruitmentVisible = true;

  }

  async openStartOfferManagement(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isStartOfferRecruitmentVisible = true;

  }

  async openEndOfferManagement(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isEndOfferRecruitmentVisible = true;

  }


  async openOnHold(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isOnHoldRecruitmentVisible = true;

  }
   async openCloseRecruitmentNew(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isCloseInternalOrExternalVisible = true;

  }
  handleCloseRecruitment() {
  if (this.hireType === 'internal') {
    // Internal: just end the recruitment
    this.sendCloseRecruitment();
  } else if (this.hireType === 'external') {
    // External: go to onboarding page
   this.router.navigate(['/newhire', this.UpdateRequest.id], {
    state: {note:this.message}
   });
  }
}



  async openOfferAccepted(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isAcceptOfferRecruitmentVisible = true;

  }
  async openCloseRecruitment(data: ManPowerDto) {
    
    this.UpdateRequest = data;
    this.isCloseRecruitmentVisible = false;

  }
  
  async loadRecords(filter: any) {
    
    this.currentUser = this.tokenService.getInfo();
    var obj: any = {}
    obj.reportParam = "Approved";
    let resRequests = await this.manpowerrecruitmentService.RequestByStatus(obj).toPromise();

    // for (const request of resRequests.responseData) {
    //   
    //   if (request.vacancyStatus == "Pending") {
    //     this.startAdvertVisible = true;
    //   }
    //   if (request.vacancyStatus == "Advert_Ongoing") {
    //     this.endAdvertVisible = true;
    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "Advert_Ended") {
    //     this.startShortlistingVisible = true;
    //     this.startAdvertVisible = false;

    //   }
    //   if (request.vacancyStatus == "Shortlisting_Ongoing") {
    //     this.endShortlistingVisible = true;
    //     this.startShortlistingVisible = false;
    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "Shortlisting_Concluded") {
    //     this.startInterviewVisible = true;
    //     this.startShortlistingVisible = false;
    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "Interview_Ongoing") {
    //     this.endInterviewVisible = true;
    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "Interview_Concluded") {
    //     this.startOfferManagementVisible = true;
    //     this.startInterviewVisible = false;
    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "OfferManagement_Ongoing") {
    //     this.EndOfferManagementVisible = true;
    //     this.startOfferManagementVisible = false;
    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "OfferManagement_Concluded") {
    //     this.OfferAcceptedVisible = true;

    //     this.startAdvertVisible = false;
    //   }
    //   if (request.vacancyStatus == "OfferAccepted") { this.onHoldVisible = true; }
    //   // if (request.vacancyStatus == "onHold") { this.onHoldVisible = true; }

    // }



    
    this.Requests = <ManPowerDto[]>resRequests.responseData;

    try {
      this.Requests?.sort((n1, n2) => {
        if (n1.id > n2.id) {
          return -1;
        }

        return 0;
      });
    } catch (error) {

    }

  }

  handleText(): void {
    this.isPendingpprovalModalVisible = false;

  }


  async beginCancel(data: ManPowerDto) {
    
    this.closeModalTitle = "Cancel Contract ";
    this.isCloseModalVisible = true;
    this.isCancelVisible = true;
    this.UpdateRequest = data;
  }

  async handleSubmit() {
    
    var obj: any = {}
    obj.NextApprovalEmail = this.UpdateRequest.nextToApprove;
    obj.RequestId = this.UpdateRequest.id;

    let resRequests = await this.manPowerService.SendManualReminder(obj).toPromise();
    this.Requests = <ManPowerDto[]>resRequests.responseData;
  }

  populateDrowdown(data: ManPowerDto, validStatus:string): boolean {

    if (data.vacancyStatus == validStatus) {
      return true
    }
    return false;

  }


 populateoNHoldDrowdown(data: ManPowerDto, validStatus:string): boolean {
       
       if (data.vacancyStatus != 'Closed' && data.vacancyStatus != 'OnHold') {
        return true;
      }

       return false;
        
       }

  print(requestReference: string, templateId: string) {
    debugger
    this.documentService.DownloadPDF(templateId, `Manpower Request - ${requestReference}`);
  }
  
  prints(requestReference: string, templateId: string) {
    debugger
    this.documentService.DownloadPDF(templateId, `Manpower Recruitment - ${requestReference}`);
  }
  cancel(): void {
    return;
  }

  close(): void {
    this.ViewManpowerRecruitment = false;
    this.canPrint = false;
    this.ViewManpowerRequestVisible = false;
    
  }

  async getJD(datas: ManPowerDto) {
    // this.ViewManPowerVisible = true;
    
    this.UpdateRequest = datas;
    let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
    

    this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;
    var receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64,", "")
    const b = Uint8Array.from(atob(receivedfile), c => c.charCodeAt(0));
    const blob = new Blob([b], { type: "application/octet-stream" });
    FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);

  }

  async showDocument(datas: ManPowerDto) {
    // this.open();
    
    let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
    

    this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;

    this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64,", "")
    this.pdf = getJDRequest.responseData[0].documentContent

    // this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;

    // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
    const pdfWindow = window.open("")!;
    pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +
      encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>")

  }

  getStatusColor(status: string): string {
    switch (status) {
      case "Pending":
        return 'badge badge-warning';
      case "Advert_Ongoing":
        return 'badge badge-secondary';
      case "Advert_Ended":
        return 'badge badge-secondary';
      case "Shortlisting_Ongoing":
        return 'badge badge-success';
      case "Shortlisting_Concluded":
        return 'badge badge-success';
      case "Interview_Ongoing":
        return 'badge badge-light';
      case "Interview_Concluded":
        return 'badge badge-light';
      case "OfferManagement_Ongoing":
        return 'badge badge-info';
      case "OfferManagement_Concluded":
        return 'badge badge-info';
      case "OfferAccepted":
        return 'badge badge-success';
      case "OnHold":
        return 'badge badge-warning';
      case "Closed":
        return 'badge badge-danger';

      default:
        return 'badge badge-info';
    }

  }


  getColor(status: string): string {
    switch (status) {
      case "MEDIUM":
        return 'badge badge-warning';
      case "LOW":
        return 'badge badge-success';
      case "HIGH":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

}